import React from "react";
import "./Map.css";

export default function BengaluruMap() {
  return (
    <section className="bloremap-wrapper">
      <div className="bloremap-container">
        <iframe
  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3921.939337835118!2d77.2545079!3d10.583916000000002!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba9cd94afde7d6f%3A0x98c5011f8bad37b3!2sCM%20Group%20Of%20Companies!5e0!3m2!1sen!2sin!4v1785738071079!5m2!1sen!2sin"
  width="100%"
  height="450"
  style={{ border: 0 }}
  allowFullScreen
  loading="lazy"
  referrerPolicy="strict-origin-when-cross-origin"
></iframe>
      </div>
    </section>
  );
}
